<template>
    <span style="vertical-align: middle; display: inline-block;">
        <a-tooltip placement="top" style="vertical-align: middle; ">
            <template slot="title">
                <span>{{ userDepartment.name }}</span>
            </template>
            <span class="department-badge" style="overflow: auto">
                <svg data-toggle="tooltip" data-placement="top" width="32px" height="32px"
                     style="vertical-align: middle;" v-bind:class="{'white-border': border}">
                    <circle cx="16" cy="16" r="16" :fill="color"></circle>
                    <text x="50%" y="50%" text-anchor="middle" fill="white" font-size="12px" font-family="Arial"
                          dy=".35em">
                        {{ departmentInitials }}
                    </text>
                </svg>
                <span v-if="displayName">{{ userDepartment.name }}</span>
            </span>
        </a-tooltip>
    </span>
</template>

<script>
import color from '~/util/color'

export default {
  name: 'UserDepartmentBadgeComponent',
  props: {
    userDepartment: {
      type: Object,
      required: true
    },
    displayName: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    departmentInitials () {
      return this.userDepartment.name.substring(0, 2).toUpperCase()
    },
    color () {
      return color.getRandomPastelColor(color.hashCode(this.departmentInitials))
    }
  }
}
</script>
<style>
.department-badge {
  vertical-align: inherit;
  display: inline-block;
  padding: 0.5rem;
  margin: -.5rem 0;
  border-radius: .2rem;
  transition: background-color .5s;
}

.department-badge:hover {
  background-color: #0000000a;
}

.department-badge .white-border {
  border-radius: 100%;
  border: solid white 2px;
}
</style>